import React, { useEffect, useRef, useState } from "react";
import PaymentMethodCard from "./PaymentMethodsCard/PaymentMethodsCard";
import { PaymentMethod, PaymentMethodStatus } from "./PaymentMethodsInterface";
import { IconStripe } from "../../../assets/icons/icons";
import {
  getAllPaymentMethods,
  getPaymentMethodConfiguration,
  updatePaymentMethodActive,
  updatePaymentMethodInactive,
} from "../../../services/payment/payment";
import { decodeTokenService } from "../../../services/decodeTokenService";
import Modal from "../modal";
import PaymentMethodsNotConfiguration from "../PaymentMethodsModalContent/PaymentMethodsNotConfiguration";
import { handleConnect } from "./paymentUtils";
import Loader from "../../common/Loader";
import PaymentMethodsError from "../PaymentMethodsModalContent/PaymentMethodsError";
import PaymentMethodsSuccess from "../PaymentMethodsModalContent/PaymentMethodsSuccess";

const PaymentMethods: React.FC = () => {
  const [methods, setMethods] = useState<PaymentMethod[]>([]);
  const [openModalError, setOpenModalError] = useState<boolean>(false);
  const [openModalSuccess, setOpenModalSuccess] = useState<boolean | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(false);
  const methodsStatus = useRef<PaymentMethodStatus[]>([]);
  const selectMethod = useRef<string>("stripe");
  const icons = {
    stripe: <IconStripe />,
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const confirm = urlParams.get("confirm");
    if (confirm === "true") {
      setOpenModalSuccess(true);
    }
    if (confirm === "false") {
      setOpenModalSuccess(false);
    }
  }, []);

  const handleGetMethods = () => {
    getAllPaymentMethods()
      .then((res) => {
        setMethods(res);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  useEffect(() => {
    setLoading(true);
    const userId = decodeTokenService.getUserIdFromToken() || "";
    getPaymentMethodConfiguration()
      .then((res) => {
        methodsStatus.current = res;
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
    handleGetMethods();
  }, []);

  const handleToggle = async (id: string, active: boolean) => {
    if (methodsStatus.current.length === 0) {
      selectMethod.current = id;
      setOpenModalError(true);
      return;
    }

    if (active) {
      updatePaymentMethodActive(id)
        .then((res) => {})
        .catch((err) => {
          console.error(err);
        });
    }

    if (!active) {
      updatePaymentMethodInactive(id)
        .then((res) => {})
        .catch((err) => {
          console.error(err);
        });
    }
  };

  return (
    <div className="flex gap-4">
      {!loading ? (
        methods.map((method) => (
          <PaymentMethodCard
            notConfigured={methodsStatus.current.length === 0}
            key={method.id}
            name={method.id}
            logoSrc={icons[method.id as keyof typeof icons]}
            isActive={
              methodsStatus.current.find((status) => status.id === method.id)
                ?.active ?? false
            }
            isConnected={
              methodsStatus.current.find((status) => status.id === method.id)
                ?.already_configured ?? false
            }
            onToggle={() =>
              handleToggle(
                method.id,
                !methodsStatus.current.find((status) => status.id === method.id)
                  ?.active
              )
            }
            onConnect={() => handleConnect(method.id)}
            onUpdate={() => handleConnect(method.id)}
          />
        ))
      ) : (
        <div className="flex justify-center items-center h-screen w-full">
          <Loader />
        </div>
      )}
      {openModalError && (
        <Modal onClose={() => setOpenModalError(false)}>
          <PaymentMethodsNotConfiguration id={selectMethod.current} />
        </Modal>
      )}
      {openModalSuccess === null ? (
        <></>
      ) : openModalSuccess ? (
        <Modal onClose={() => setOpenModalSuccess(null)}>
          <PaymentMethodsSuccess
            handleClose={() => setOpenModalSuccess(null)}
          />
        </Modal>
      ) : (
        <Modal onClose={() => setOpenModalSuccess(null)}>
          <PaymentMethodsError id={selectMethod.current} />
        </Modal>
      )}
    </div>
  );
};

export default PaymentMethods;
